module.exports = __webpack_public_path__ + "img/singapore.c8036ce8.svg";